import { FC } from 'react'
import { Application, EntryPoint } from '@wellesley/openapi'
import { AppAvatar } from '../../AppAvatar'
import { useSetLastApp, useGetAppLink } from '@wellesley/apps'
import { useIsItemActive } from '../hooks/useIsItemActive'
import { Item } from '../Item'

export type AppListSize = 'sm' | 'lg'

type AppItemProps = {
  app: Application
  size: AppListSize
  entryPoint: EntryPoint
  username?: string
  groupname?: string
  onClick?: () => void
}

export const AppItem: FC<AppItemProps> = ({
  app,
  size,
  username,
  groupname,
  entryPoint,
  onClick,
}) => {
  const link = useGetAppLink({ entryPoint })(app, groupname)
  const isActive = useIsItemActive(link)

  useSetLastApp({ link, username, groupname, isActive })

  return (
    <Item
      title={app.name}
      link={link}
      size={size}
      isActive={isActive}
      onClick={onClick}
    >
      <AppAvatar name={app.name} icons={app.manifest.icons} />
    </Item>
  )
}
